import { render } from "./RequestedUoCrb.vue?vue&type=template&id=eb9b12be&scoped=true"
import script from "./RequestedUoCrb.vue?vue&type=script&lang=js"
export * from "./RequestedUoCrb.vue?vue&type=script&lang=js"

import "./RequestedUoCrb.vue?vue&type=style&index=0&id=eb9b12be&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9b12be"]])

export default __exports__